// frontend/routes.ts
import {createBrowserRouter, RouteObject} from 'react-router-dom';
import MainLayout from '@/views/MainLayout';
import {ErrorBoundary} from '@/shared/components/ErrorBoundary';
import {SecureWrapperView} from '@/shared/components/SecureWrapperView';
import Home from "@/views/dashboard/Home";

// Temporary imports until modules are created

import AccountActivities from "@/views/accounts/AccountActivities";
import AccountBalances from "@/views/accounts/AccountBalances";
import AttachmentManager from "@/views/posts/AttachmentManager";
import LoginFormView from "@/views/auth/LoginFormView";
import {CustomerProfileManagementView} from "@/views/profile/CustomerProfileManagementView";
import ChangePasswordView from "@/views/profile/ChangePasswordView";
import CustomerTypeManagementView from "@/modules/views/CustomerTypeManagementView";
import SelfOnboardingConfigManagement from "@/modules/onboarding/views/SelfOnboardingConfigManagement";
import BillPaymentView from "@/views/payments/BillPaymentView";
import ForgotPasswordView from "@/modules/auth/views/ForgotPasswordView";
import { publicInvitationRoutes } from "@/modules/invitations";
import { ProfileManagementModule } from "@/modules/admin/profile-management";

// Function to help visualize route structure
const getRouteStructure = (routes: RouteObject[]): any[] => {
  return routes.map(route => ({
    path: route.path,
    children: route.children ? getRouteStructure(route.children) : undefined,
    index: route.index,
  }));
};

// Legacy routes that will be moved to modules later
const legacyRoutes: RouteObject[] = [
  {
    path: '/payments/make',
    element: <BillPaymentView />,
  },
  {
    path: 'accounts/deposit',
    element: <BillPaymentView />,
  },
  {
    path: 'accounts/activities',
    element: <AccountActivities />,
  },
  {
    path: 'accounts/balances',
    element: <AccountBalances />,
  },
  {
    path: 'admin/general/customer-type-management',
    element: <CustomerTypeManagementView />,
  },
  {
    path: 'admin/general/self-onboarding-config',
    element: <SelfOnboardingConfigManagement />,
  },
  {
    path: '/admin/attachments/management',
    element: <AttachmentManager />,
  },
  {
    path: 'user/profile',
    element: <CustomerProfileManagementView />,
  },
  {
    path: 'user/change-password',
    element: <ChangePasswordView />,
  },
];

// Legacy auth routes that will be moved to auth module
const legacyAuthRoutes: RouteObject[] = [
  {
    path: '/forgot-password',
    element: <ForgotPasswordView />,
  }
];

export const createAppRouter = (moduleRoutes: RouteObject[]) => {
  // Define routes to create a browser router
  const routes: RouteObject[] = [
    {
      path: '/',
      errorElement: <ErrorBoundary />,
      children: [
        {
          path: 'login',
          element: <LoginFormView />,
        },
        ...legacyAuthRoutes,
        ...publicInvitationRoutes,
        {
          path: '',
          element: <SecureWrapperView />,
          children: [
            {
              element: <MainLayout />,
              children: [
                {
                  index: true,
                  element: <Home />,
                },
                // Legacy routes
                ...legacyRoutes,
                // Module routes
                ...moduleRoutes,
                ...ProfileManagementModule.routes
              ],
            },
          ],
        },
      ],
    },
  ];

  console.log('Route structure:', getRouteStructure(routes));
  // Create a browser router with a basename that excludes /public paths
  return createBrowserRouter(routes, {
    // This should prevent React Router from handling /public/* routes
    basename: window.location.pathname.startsWith('/public') ? undefined : '/'
  });
};